import { render, staticRenderFns } from "./PaymentSelector.vue?vue&type=template&id=4727370a&"
import script from "./PaymentSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentSelector.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports